export const errorTypes = {
  NEW_ERROR: "NEW_ERROR",
  CLEAN_ERROR: "CLEAN_ERROR",
};
